module.exports = __webpack_public_path__ + "static/media/redsapp3.d4ee4176.png";